let pendingResolver = null;

const openContactsGateAndWait = () =>
    new Promise((resolve) => {
        if (pendingResolver) {
            resolve(false);
            return;
        }
        pendingResolver = resolve;
        window.dispatchEvent(new Event('contacts:gate-blocked'));
    });

const resolveContactsGate = (verified) => {
    const settle = pendingResolver;
    pendingResolver = null;
    if (settle) settle(Boolean(verified));
};

const isContactsGatePending = () => pendingResolver !== null;

export { openContactsGateAndWait, resolveContactsGate, isContactsGatePending };
